export default {
  FETCH_SAVED_DESIGNS_START: 'account/FETCH_SAVED_DESIGNS_START',
  FETCH_SAVED_DESIGNS: 'account/FETCH_SAVED_DESIGNS',
  FETCH_SAVED_DESIGNS_SUCCESS: 'account/FETCH_SAVED_DESIGNS_SUCCESS',
  FETCH_SAVED_DESIGNS_FAILED: 'account/FETCH_SAVED_DESIGNS_FAILED',
  FETCH_PROFILE: 'account/FETCH_PROFILE',
  FETCH_PROFILE_FAILED: 'account/FETCH_PROFILE_FAILED',
  FETCH_VOUCHER: 'account/FETCH_VOUCHER',
  FETCH_VOUCHER_FAILED: 'account/FETCH_VOUCHER_FAILED',
  LOCATION: 'account/LOCATION',
  LOCATION_LOADED: 'account/LOCATION_LOADED',
  LOCATION_FAILED: 'account/LOCATION_FAILED',
  SET_PREFER_SINGLES: 'account/SET_PREFER_SINGLES',
  SELECT_SAVED_DESIGN_INDEX: 'account/SELECT_SAVED_DESIGN_INDEX',
  UPDATE_INTERNAL_USER: 'account/UPDATE_INTERNAL_USER',
  UPDATE_LTV_CUSTOMER: 'account/UPDATE_LTV_CUSTOMER',
  UPDATE_PROFILE: 'account/UPDATE_PROFILE',
  UPDATE_SDFU: 'account/UPDATE_SDFU'
};
